import React, { FC } from 'react';

type DashboardInsightsVisitorsProps = {};

export const DashboardInsightsVisitors: FC<DashboardInsightsVisitorsProps> = () => {
  return <div>Coming soon!</div>;
};
